import React, { Component } from 'react';
import { CSVLink } from "react-csv";
import map from 'lodash/map';
import get from 'lodash/get';
import moment from 'moment';
import unionBy from 'lodash/unionBy';
import isEmpty from 'lodash/isEmpty';
import './ExportToCsv.css';

function getKeyValue(key, object) {
  return object.metrics[key] instanceof Array && typeof object.metrics[key] !== undefined ? object.metrics[key].length : 0;
};

const exportMessage = 'Export to CSV';
class ExportToCSV extends Component {

  getMetricsDynamicHeader = (data) => {
    const headersArray = [];
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        headersArray.push({ label: this.getColumnName(key), key: this.getColumnId(key) });
      }
    }
    return headersArray;
  }
  getUserName = (item) => {
    if (!isEmpty(item.firstName) || !isEmpty(item.lastName)) {
      return `${item.firstName} ${item.lastName}`
    }
    return 'NA';
  }
  getColumnName = (columnName) => {
    const { userMetrices } = this.props;
    const columnDetails = userMetrices.filter((e) => e.id === columnName);
    return !isEmpty(columnDetails) ? columnDetails[0].name : '';
  }
  getColumnId = (columnName) => {
    const { userMetrices } = this.props;
    const columnDetails = userMetrices.filter((e) => e.id === columnName);
    return !isEmpty(columnDetails) ? columnDetails[0].id : '';
  }

  getData = (data) => {
    const a = this.getMetricsDynamicHeader(get(this.props.Analytics[0], 'metrics', []))
    const csvData = [];
      map(data, (d) => {
        let eachUserRow = {
          username: this.getUserName(d),
          email: !isEmpty(d.email) ? d.email : 'NA',
          datejoined: moment(d.createDate).format('MM/DD/YYYY'),
          role: !isEmpty(d.role) ? d.role : 'NA',
          position: !isEmpty(d.title) ? d.title : 'NA',
          office: !isEmpty(d.office) ? d.office : 'NA',
          Enterprise: !isEmpty(d.organization) ? d.organization : 'NA'
        }
        a.forEach(function (arrayItem) {
          eachUserRow[arrayItem.key] = getKeyValue(arrayItem.key, d);
        });
        csvData.push(eachUserRow);
      });
    return csvData;
  }

  render() {
    let UsersStaticHeaders = [
      { label: "Name", key: "username" },
      { label: "Email", key: "email" },
      { label: "Date Joined", key: "datejoined" },
      { label: "Role", key: "role" },
      { label: "Position", key: "position" },
      { label: "Office", key: "office" }
    ];

    let DynameicHeaders = this.getMetricsDynamicHeader(get(this.props.Analytics[0], 'metrics', []));
    let headers = unionBy(UsersStaticHeaders, DynameicHeaders);

    const { Analytics } = this.props;
    return (
      <div className="col-lg-12 col-md-12 col-sm-12 tool-list-font text-right">
        <span className="linkclass" style={{ lineHeight: '42px' }}><i className="flaticon-export" style={{ marginRight: '8px' }}></i>
          <CSVLink
            data={ this.getData(Analytics) }
            headers={headers}
            filename={`Users Analytics-${moment().format("MM/DD/YYYY")}.csv`}
            separator={","}
            target="_blank"
          >{exportMessage}</CSVLink>
        </span>
      </div>
    )
  }
}

export default ExportToCSV;